import { create } from 'zustand';

type ErrorScreenStore = {
    isErrorScreenVisible: boolean;
    setErrorScreenVisible: (visible: boolean) => void;
};

export const useErrorScreenStore = create<ErrorScreenStore>((set) => ({
    isErrorScreenVisible: false,
    setErrorScreenVisible: (visible) => set({ isErrorScreenVisible: visible }),
}));
